import { render, staticRenderFns } from "./ProgrammeProfileView.vue?vue&type=template&id=d75e88ca&"
import script from "./ProgrammeProfileView.vue?vue&type=script&lang=js&"
export * from "./ProgrammeProfileView.vue?vue&type=script&lang=js&"
import style0 from "./ProgrammeProfileView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports